<template>
    <div class="">

        <div class="TQ_width_36px TQ_borderRadius TQ_box_shadow TQ_grid_row_auto1fr TQ_grid_gap_4px TQ_height_100p">

            <!--<tq-image :pb_src_r="ass_img_oneStar_w"-->
                      <!--:class="co_getCurrentColor_s"-->
                      <!--class="TQ_width_20px TQ_padding_4px TQ_borderRadius TQ_margin_4px "/>-->

            <div></div>

            <div class="lc_pointBar">

                <div class="lc_finishAreaHr"
                     v-if="!co_getToLine1_b"
                     :style="{bottom:co_finishLine1Height_s}">
                    <tq-image :pb_src_r="ass_img_unlock2_w" class="TQ_width_16px TQ_bg_green TQ_padding_4px TQ_borderRadius TQ_center"/>
                    <hr>
                </div>

                <div class="lc_finishAreaHr2"
                     v-if="co_showLine2_b && !co_getToLine2_b"
                     :style="{bottom:co_finishLine2Height_s}">
                    <tq-image :pb_src_r="ass_img_threeStars" class="TQ_width_16px TQ_bg_purple TQ_padding_4px TQ_borderRadius"/>
                    <hr>
                </div>

                <div class="lc_pointBar2 TQ_width_100p"
                     :class="co_getCurrentColor_s"
                     :style="{height:co_currentPointsHeight_s}" >
                </div>

                <div class="lc_points TQ_width_100p" :style="{height:co_currentPointsHeight_s}">
                    <div>{{p_currentPoints_n}}</div>
                    <hr class="lc_hr">
                    <div>{{p_totalPoints_n}}</div>
                </div>


            </div>

        </div>
    </div>

</template>

<script>
    import TqOnTopContainer from "./TqOnTopContainer";
    import {ass_img_oneStar_w, ass_img_threeStars, ass_img_unlock2_w} from "../../assets/scripts/Ass_Files";
    import TqImage from "./TqImage";
    export default {
        name: "tqStatingPointsBar",
        components: {
            TqImage,
            TqOnTopContainer
        },
        props:{
            p_totalPoints_n:{
                type: Number,
                require: true,
            },
            p_currentPoints_n:{
                type: Number,
                require: true,
            },
            p_finishLine1Points_n:{
                type: Number,
                require: true,
            },
            p_finishLine2Points_n:{
                type: Number,
                require: true,
            }
        },
        data(){
            return {
                ass_img_oneStar_w : ass_img_oneStar_w,
                ass_img_unlock2_w : ass_img_unlock2_w,
                ass_img_threeStars : ass_img_threeStars,
            }
        },
        computed:{
            co_currentPointsHeight_s(){
                return (this.p_currentPoints_n / this.p_totalPoints_n)*100  + "%"
            },
            co_finishLine1Height_s(){
                return (this.p_finishLine1Points_n / this.p_totalPoints_n)*100  + "%"
            },
            co_finishLine2Height_s(){
                return (this.p_finishLine2Points_n / this.p_totalPoints_n)*100  + "%"
            },
            co_getToLine1_b(){
                return this.p_currentPoints_n>=this.p_finishLine1Points_n
            },
            co_showLine2_b(){
                return this.p_finishLine2Points_n != null
            },
            co_getToLine2_b(){
                return this.p_currentPoints_n>=this.p_finishLine2Points_n
            },
            co_getCurrentColor_s(){
                if(this.co_showLine2_b && this.co_getToLine2_b){
                    return 'TQ_bg_purple'
                } else if(this.co_getToLine1_b){
                    return 'TQ_bg_green'
                }else{
                    return 'TQ_bg_red'
                }
            }
        }
    }
</script>

<style scoped lang="scss">



    .lc_pointBar{
        /*box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);*/
        position: relative;
        background: white;
        border-radius: 0 0 5px 5px;
        border: 1px solid black;
        margin-top: -4px;
    }

    .lc_pointBar2{
        position: absolute;
        bottom: 0;
        left: 0;
        border-radius: 0 0 5px 5px;
        min-height: 36px;
        box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
        border-top:1px solid black
    }

    .lc_points{
        position: absolute;
        bottom: 0;
        left: 0;
        color: white;
        min-height: 40px;
        margin-bottom:  -4px;
        font-size: 14px;
    }

    .lc_hr{
        margin: 0 2px;
        border:1px solid white;
    }

    .lc_finishAreaHr{
        position: absolute;
        left: 0;
        width: 100%;
        margin-bottom: -8px;

        hr{
            border: 1px solid var(--color-green);
            margin-top: -16px;
        }
    }

    .lc_finishAreaHr2{
        position: absolute;
        left: 0;
        width: 100%;
        margin-bottom: -8px;

        hr{
            border: 1px solid #501078;
            border: 1px solid var(--color-purple);
            margin-top: -16px;
        }
    }

</style>